export default __webpack_public_path__ + "static/media/bradley_frew.8097f0b7.jpg";